'use client';

import { useEffect } from 'react';
import Favicon from '@/allocate/ui/common/Favicon';
import ApplicationFallback from '@framework/error-handling/ErrorBoundary/ApplicationFallback';
import Logger from '@framework/sentry/Logger';

import '@/allocate/ui/styles/globalStyles.scss';

interface IGlobalErrorProps {
  error: Error & { digest?: string },
}

export default function GlobalError({ error }: IGlobalErrorProps) {
  useEffect(() => {
    Logger.error({
      message: 'Global error boundary',
      error,
      context: { digest: error.digest },
    });
  }, [error]);

  return (
    <html lang="en" style={ { scrollBehavior: 'smooth' } }>
      <head>
        <link
          href="https://fonts.googleapis.com/css?family=Roboto:400,400i,500,500i,600,700,700i|Open+Sans:400,400i,500,500i,600,700,700i&display=swap"
          rel="stylesheet"
        />
        <Favicon />
      </head>
      <body>
        <ApplicationFallback />
      </body>
    </html>
  );
}
